import { injectHeaders } from "@ofqual/portal-core/core/utils/listHelpers";
import { Model } from "@ofqual/portal-core/core/types";

export const processConditions = (data: Model[]) => {
  const sortedData = data
    .map((item) => ({
      id: item.id,
      label: `${item.code}: ${item.description}`,
      group: item.conditionCategory,
      active: item.active,
    }))
    .sort((a, b) => {

      //Sort the groups
      if (a.group > b.group) {
        return 1;
      } else if (a.group < b.group) {
        return -1;
      }

      //Sort items inside a group by the integer contained within the part of the label before the colon
      if (parseInt(a.label.split(':')[0].replace( /^\D+/g, '')) > parseInt(b.label.split(':')[0].replace( /^\D+/g, ''))) {
        return 1;
      } else if (parseInt(a.label.split(':')[0].replace( /^\D+/g, '')) < parseInt(b.label.split(':')[0].replace( /^\D+/g, ''))) {
        return -1;
      }

      return 0;
    });

  return injectHeaders(sortedData, (item) => item.group);
};

